import Axios from '../../../utils/axios'

export const fetchInquiryDashboardData = (data) => {
  return dispatch => {
    Axios.get('/admin/inquiry-messages', dispatch, 'GET_INQUIRY_DASHBOARD_DATA', data)
  }
}